module.exports = __webpack_public_path__ + "static/media/arrow-up.54327bd6.svg";